/**
 * AuthGateModal — Non-dismissable modal that appears over gated
 * mobile screens (Settings, Profile, My Lists, My Deals, Groups)
 * when the visitor is not logged in.
 *
 * Register / Login use the existing SocialPulse JWT auth via the
 * regular /login and /register routes; on success the user is
 * redirected back to the mobile shell.
 */
import { Link, useLocation } from "react-router-dom";

const FP_PURPLE = "#653091";
const FP_GREEN = "#9CCA45";

export default function AuthGateModal() {
  const { pathname } = useLocation();
  const returnTo = encodeURIComponent(pathname || "/m");
  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center px-6"
      style={{ background: "rgba(0,0,0,0.45)" }}
      data-testid="mobile-auth-gate"
    >
      <div className="w-full max-w-md bg-white rounded-3xl p-6 shadow-2xl">
        <div className="flex flex-col items-center">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center mb-4"
            style={{ background: FP_PURPLE }}
          >
            <span style={{ color: FP_GREEN, fontFamily: "serif", fontWeight: 700 }}>FP</span>
          </div>
          <p className="text-center text-base font-semibold mb-6">
            Please register and log in to access the full features of Food Pulse!
          </p>
          <div className="w-full flex gap-3">
            <Link
              to={`/register?next=${returnTo}`}
              data-testid="auth-gate-register"
              className="flex-1 text-center px-4 py-3 rounded-xl text-white font-semibold"
              style={{ background: FP_GREEN }}
            >
              Register
            </Link>
            <Link
              to={`/login?next=${returnTo}`}
              data-testid="auth-gate-login"
              className="flex-1 text-center px-4 py-3 rounded-xl text-white font-semibold"
              style={{ background: FP_GREEN }}
            >
              Login
            </Link>
          </div>
          <Link
            to="/m"
            data-testid="auth-gate-close"
            className="mt-4 text-xs opacity-60 underline"
          >
            Continue browsing as guest
          </Link>
        </div>
      </div>
    </div>
  );
}
